// Local storage facade for global messages
const getLocalStorageKey = (id: string): string => `willys.GlobalMessage-${id}`;
export const getGlobalMessageDisplayState = (uid: string) => {
  return localStorage.getItem(getLocalStorageKey(uid));
};
export const setGlobalMessageDisplayState = (uid: string) => {
  localStorage.setItem(getLocalStorageKey(uid), 'true');
};
